const initialState = () => ({
  results: [],
});

const state = initialState();

export default state;
